import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnowledgeBaseService } from '../../services/knowledge-base.service';
import { AppConfigService } from '../../services/app-config.service';
import { Article } from '../../models/knowledge-base';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InstanceTypes } from '../../models/instance-types';

@Component({
  selector: 'article-full-page',
  templateUrl: './article-full-page.component.html',
  styleUrls: ['./article-full-page.component.css'],
  standalone: false
})
export class ArticleFullPageComponent implements OnInit {
  public articleId: number;
  public article: Article;
  public articleHtml: SafeHtml;
  get isClientPortal() {
    return this.env.instanceType === InstanceTypes.ClientPortal;
  }
  constructor(
    private kbService: KnowledgeBaseService,
    private route: ActivatedRoute,
    private appConfigService: AppConfigService,
    private sanitizer: DomSanitizer,
    @Inject('env') private env: any
  ) {}

  ngOnInit(): void {
    // task 9700 - fetch the articles in the folder and grab the matching article by id
    const folderId = this.appConfigService.getConfig().KnowledgeBase.ReleaseNotesFolderId;
    this.articleId = +this.route.snapshot.paramMap.get('id');

    this.kbService.getArticlesInFolder(folderId).subscribe(resp => {
      this.article = resp.find(article => article.Id == this.articleId);
      this.articleHtml = this.sanitizer.bypassSecurityTrustHtml(this.article.Content);
    });
  }
}
